import { useQuery } from '@tanstack/react-query'
import { t } from 'i18n-js'
import { useDispatch } from 'react-redux'
import { getUserResortList } from 'services/auth.service'
import api from 'services/baseApi'
import { User } from 'store/ducks'
import { setUserResortList, userInfoSuccess } from 'store/ducks/auth/actions'

const useUser = () => {
  const dispatch = useDispatch()
  return useQuery<User>({
    queryKey: ['user'],
    queryFn: async () => {
      const { data } = await api.get('user')
      const resortListData = await getUserResortList()

      dispatch(userInfoSuccess(data))
      dispatch(setUserResortList(resortListData))
      return data
    },
    throwOnError(error) {
      throw Error(t(error.name))
    },
    enabled: false,
    retry: 3
  })
}
export default useUser
